<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vi"></a><a id="page_vii"><em>Contents</em></a></h1><a id="page_vii">
</a><p class="toc-fm"><a id="page_vii"></a><a href="#/006_Figures#fm-1"><em>List of Figures</em></a></p>
<p class="toc-fm"><a href="#/007_Tables#fm-2"><em>List of Tables</em></a></p>
<p class="toc-fm"><a href="#/008_Foreword#fm-3"><em>Foreword</em> by Pheme Perkins</a></p>
<p class="toc-fm"><a href="#/009_Preface#fm-4"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/010_Acknowledgments#fm-5"><em>Acknowledgments</em></a></p>
<p class="toc-fm"><a href="#/011_Abbreviations#fm-6"><em>List of Abbreviations</em></a></p>
<p class="toc-fm"><a href="#/012_EpigraphicConventions#fm-7"><em>List of Epigraphic Conventions</em></a></p>
<p class="toc-fm1"><a href="#/013_Introduction#fm-8">Introduction</a></p>
<p class="toc-chap"><span href="#/014_Chapter01#ch-1" title="Link target outside of Sample">1. <span class="pad">Imperial Divine Honors</span></span></p>
<p class="toc-chap"><span href="#/015_Chapter02#ch-2" title="Link target outside of Sample">2. <span class="pad">Imperial Divine Honors, Paul, and the Philippian Church</span></span></p>
<p class="toc-chap"><span href="#/016_Chapter03#ch-3" title="Link target outside of Sample">3. <span class="pad">Imperial Divine Honors, Paul, and the Thessalonian Church</span></span></p>
<p class="toc-chap"><span href="#/017_Chapter04#ch-4" title="Link target outside of Sample">4. <span class="pad">Imperial Divine Honors, Paul, and the Corinthian Church</span></span></p>
<p class="toc-bm1"><span href="#/018_Conclusion#bm-1" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-bm"><span href="#/019_Appendix01#bm-2" title="Link target outside of Sample"><em>Appendix 1: Inscriptions</em></span></p>
<p class="toc-bm"><span href="#/020_Appendix02#bm-3" title="Link target outside of Sample"><em>Appendix 2: Reconstructed Julio-Claudian Imperial Calendar in Philippi and Corinth</em></span></p>
<p class="toc-bm"><span href="#/021_Bibliography#bm-4" title="Link target outside of Sample"><em>Bibliography</em></span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?76db940b